import React from 'react'
import BeneIcon from 'custom/assets/common-icons/bene-image.svg'

export default function BeneficiaryDisplay({ beneDetails = {} }) {
  return (
    <div className='d-flex source-account-section'>
      <div className='image'>
        <img
          style={{ height: 30, width: 30, margin: '0 auto', objectFit: 'contain',display:'block' }}
          src={beneDetails?.image === null ? BeneIcon : beneDetails?.image}
        />
      </div>
      <div>
        <label>{beneDetails?.beneName}</label>
        <h3>{beneDetails?.beneAccNo}</h3>
      </div>
    </div>
  )
}
